export default {
    name: "Enable",
    title: "Enable",
    icon: "mdi-check-circle-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};